import type { ReactNode } from "react";

import { type HereAndNowTab, selectIsDetailsOpen, selectSelection, useHaNView } from "@lib/logic";
import { cn } from "@utils";

type HaNSearchResultItemProps = {
  // The tab that opens the result's details. A facility category has none.
  tab?: HereAndNowTab;
  selectionId?: string;
  onSelect: () => void;
  children: ReactNode;
};

export const HaNSearchResultItem = ({ tab, selectionId, onSelect, children }: HaNSearchResultItemProps) => {
  const isOpen = useHaNView(state => {
    return !!tab && selectIsDetailsOpen(tab)(state) && selectSelection(tab)(state)?.id === selectionId;
  });

  return (
    <li>
      <button
        type="button"
        aria-current={isOpen || undefined}
        className={cn(
          "flex w-full items-center rounded-lg border-2 border-transparent p-1.5 text-left focus-visible:border-mapiq-black-800* focus-visible:outline-none [@media(hover:hover)]:hover:bg-black/[0.03]",
          { "bg-black/[0.03]": isOpen },
        )}
        onClick={onSelect}>
        {children}
      </button>
    </li>
  );
};
